module.exports = "<span class=\"material-editor__pane-label\">{{ vm.getLabel() }}</span>\n<div class=\"material-editor__original\">\n    <h4 ng-if=\"vm.chapter.name\">{{ vm.chapter.name }}</h4>\n    <div class=\"material-editor__original-content\" ng-if=\"vm.chapter\" ng-bind-html=\"vm.getContent()\"></div>\n    <p class=\"desc\" ng-if=\"!vm.chapter\">\n        {{ 'authoringTool.Select a chapter to compare it with the original' | translate }}\n    </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/courses/authoringTool/editor/sourcePane/template.html
// module id = 1634
// module chunks = 0